module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-790-retro-min.e086e982.jpg";